jQuery(function($)
{
    // global: orion

    var
        { show } = orion,
        { hide } = orion,
        { resetPaginationParameters } = orion,
        { map } = orion,

        // Pseudo-Constants
        delimiterNameValue = '::',
        delimiterValues = ',',
        delimiterFilters = '~',
        requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternQ = '[q]',
        requestUriPatternAvailableFacets
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/availableFacetsHtml/?q=' + requestUriReplacePatternQ,

        // module-global variables
        $body = $('body'),
        $container = $('#custom-filter-options'),
        $filterContainer = $('.folddown-header', $container),
        $form = $('form', $filterContainer),
        $q = $('input[name=q]', $form),
        idLastRequestAvailableFacets = 0,
        idLastRequestAvailableFacetsAltered = 0,
        requestAvailableFacetsAltered,
        state = [],
        isMobileFilterOverlay = false;

    // if filter markup structure is not present, bail immediately
    if ($filterContainer.length === 0)
    {
        return;
    }

    if (orion.getShopViewCode() === 'mobile')
    {
        document.querySelector('.js-filter__result-count').textContent =
            document.querySelector('.js-category__result-counter').textContent;
    }

    function toFacetGroupName($input)
    {
        var
            value = $input.val(),
            [facetGroupName] = value.split(encodeURIComponent(delimiterNameValue));

        return facetGroupName;
    }

    function toFacetGroups($inputs)
    {
        var
            facetGroups = {};

        $inputs.each(function()
        {
            var
                $input = $(this),
                facetGroupName = toFacetGroupName($input);

            if (!facetGroups[facetGroupName])
            {
                facetGroups[facetGroupName] = [];
            }

            facetGroups[facetGroupName].push($input.val());
        });

        return facetGroups;
    }

    function getRequestUriAvailableFacets(pageCategory, q)
    {
        return requestUriPatternAvailableFacets
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternQ, q);
    }

    function filterString(facetGroups)
    {
        function toFilterStringTail(name, values, acc)
        {
            if (values.length === 0)
            {
                return acc;
            }

            return toFilterStringTail(name, values.slice(1),
                acc.replace(name + encodeURIComponent(delimiterNameValue), values[0]
					+ encodeURIComponent(delimiterValues)));
        }

        var
            filterStrings = [],
            facetName;

        for (facetName in facetGroups)
        {
            if (Object.prototype.hasOwnProperty.call(facetGroups, facetName))
            {
                filterStrings.push(toFilterStringTail(facetName, facetGroups[facetName].slice(1),
                    facetGroups[facetName][0]));
            }
        }

        return filterStrings.join(delimiterFilters);
    }

    /*
	 *function filterStringRange(facetGroups) {
	 * return filterString(facetGroups);
	 *}
	 */

    function makeRequestPromiseAvailableFacets(pageCategory, q)
    {
        var
            requestUri = getRequestUriAvailableFacets(pageCategory, q),
            requestId = idLastRequestAvailableFacets + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequestAvailableFacets += 1;

        return request;
    }

    function makeRequestPromiseAvailableFacetsAltered(pageCategory, q)
    {
        var
            requestUri = getRequestUriAvailableFacets(pageCategory, q),
            requestId = idLastRequestAvailableFacetsAltered + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequestAvailableFacetsAltered += 1;

        return request;
    }

    function filter(list, f)
    {
        var
            result = [],
            i, l;

        for (i = 0, l = list.length; i < l; i += 1)
        {
            if (f(list[i]))
            {
                result.push(list[i]);
            }
        }

        return result;
    }

    function filterEmpty(list)
    {
        return filter(list, function(item)
        {
            return (Object.prototype.hasOwnProperty.call(item, 'length') && item.length > 0);
        });
    }

    function updateResetElements()
    {
        $form.find('.filter').each(function()
        {
            if ($('input:checked', this).length === 0)
            {
                hide($('.reset', this));
            }
            else
            {
                show($('.reset', this));
            }
        });
    }

    function trimmedQuotes(str)
    {
        return str.replace(/^(?:%22)?(.*?)(?:%22)?$/, '$1');
    }

    function toValueList(value)
    {
        return value.split(encodeURIComponent(delimiterValues));
    }

    function toNameAndValue(nameValue)
    {
        var
            nameAndValue = nameValue.split(encodeURIComponent(delimiterNameValue)),
            [name] = nameAndValue,
            values;

        values = map(nameAndValue.slice(1), toValueList);

        if (nameAndValue.length > 2)
        {
            // special case price range

            values = [values.join(encodeURIComponent(delimiterNameValue))];
        }
        else if (nameAndValue.length < 2)
        {
            return [];
        }
        else
        {
            values = map(values[0], trimmedQuotes);
        }

        return [name, values];
    }

    function toStateFromQ(q)
    {
        var matches = q.match(/(.*--.*--.*--.*--)(.*)/);

        if (!matches)
        {
            return {
                'prefix': '--00--' + orion.constants.ElementsPerPage + '----',
                'filters': []
            };
        }

        if (matches[2].length === 0)
        {
            return {
                'prefix': matches[1],
                'filters': []
            };
        }

        return {
            'prefix': matches[1],
            'filters': filterEmpty(map(matches[2].split(delimiterFilters), toNameAndValue))
        };
    }

    function restoreFormFromState(state)
    {
        var
            name, values, value,
            i, j, l, m,
            selector;

        for (i = 0, l = state.length; i < l; i += 1)
        {
            [name] = state[i];
            [, values] = state[i];

            for (j = 0, m = values.length; j < m; j += 1)
            {
                value = values[j];

                selector = '[name="' + name + '_' + value + '"][value="' + name
					+ encodeURIComponent(delimiterNameValue) + encodeURIComponent('"')
					+ value
					+ encodeURIComponent('"') + '"],[id="'
					+ name + '_' + value + '"],[name="' + name + '"][value="'
					+ name + encodeURIComponent(delimiterNameValue) + value + '"]';

                $(selector, $form).prop('checked', true);
            }
        }
    }

    function updateParameterLastFilterUsed(q, lastFilterUsed)
    {
        var query = new URI(q);

        if ('' === lastFilterUsed)
        {
            query.removeQuery('last');
            return query.toString();
        }

        query.setQuery('last', lastFilterUsed);
        return query.toString();
    }

    function updateQFromPageUri()
    {
        var search = new URI(document.location.search).query(true).q;

        $q.val(search);
        state = toStateFromQ($q.val());
    }

    function restoreFormState($checkedInputs)
    {
        $checkedInputs.each(function()
        {
            var $checkedInput = $(this);

            $('input[name="' + $checkedInput.attr('name') + '"][value="' + $checkedInput.attr('value') + '"]', $form)
                .prop('checked', true)
                .parent()
                .addClass('active');
        });

        $('.custom-boxes :checked', $form).closest('li')
            .addClass('active')
            .closest('.custom-boxes')
            .addClass('has-selection');
    }

    function handleDoneAvailableFacetsAltered(lastFilterUsed, availableFacetsMarkup, $checked, markupFrame)
    {
        if (idLastRequestAvailableFacetsAltered !== requestAvailableFacetsAltered.requestId)
        {
            // stale request => discard
            console.log('stale request => discard');
            return;
        }
        console.log('handleDoneAvailableFacetsAltered');

        var
            $markupFrame = $(markupFrame),
            markup = '<div>' + availableFacetsMarkup + '</div>',
            $markupFilterLast = $('[name^="' + lastFilterUsed + '"]', markup).closest('.filter');

        $('.filter-header__container', $container).replaceWith($('.filter-header__container', $markupFrame));
        // $('.filter-main', $container).replaceWith($('.filter-main', $markupFrame));

        if (orion.getShopViewCode() === 'mobile')
        {
            document.querySelector('.js-filter__result-count').textContent =
                document.querySelector('.js-category__result-counter').textContent;
            document.querySelector('#overlay-more-filter').classList.remove('hidden');
        }

        if (lastFilterUsed !== 'productFlagsFacet')
        {
            $('.more-filter.folddown-trigger').click();
            $('[name^="' + lastFilterUsed + '"]', $form).closest('.filter')
                .replaceWith($markupFilterLast);
        }

        restoreFormState($checked);

        $body.trigger(orion.constants.EventFiltersMarkupReplaced);
        document.querySelector('#content').dispatchEvent(new Event(orion.constants.EventFiltersMarkupReplaced));

        /*
		 * Changed: inaccurate search hits should be shown now
		 *          hiding only commented out, in case this requirement changes again
		 * $("input:not(:checked)", $markupFilterLast).each(function (i, input) {
		 * 	hide($(".item-count", $(input).next("label")));
		 * });
		 */
    }

    function handleLastFilterUsed(lastFilterUsed, facetGroups, pageCategory, $checked, markupFrame)
    {
        if ('' === lastFilterUsed)
        {
            console.log('no lastFilterUsed');
            var $markupFrame = $(markupFrame);

            $('.filter-header__container', $container).replaceWith($('.filter-header__container', $markupFrame));
            // $('.filter-main', $container).replaceWith($('.filter-main', $markupFrame));
            restoreFormState($checked);

            $body.trigger(orion.constants.EventFiltersMarkupReplaced);

            // if there is no parameter "last", we're done
            return;
        }
        console.log('lastFilterUsed set');

        /*
		 * if there is a parameter "last", we have to make another request for the facets, with this last parameter removed
		 * from the filter parameter string, and then replace the last used filter element
		 */
        var rawFilterString, alteredQ;

        if (!Object.prototype.hasOwnProperty.call(facetGroups, lastFilterUsed))
        {
            handleLastFilterUsed('', facetGroups, pageCategory, $checked, markupFrame);
            return;
        }

        delete facetGroups[lastFilterUsed];

        rawFilterString = filterString(facetGroups);
        alteredQ = resetPaginationParameters(state.prefix + rawFilterString);

        requestAvailableFacetsAltered = makeRequestPromiseAvailableFacetsAltered(pageCategory, alteredQ);

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        requestAvailableFacetsAltered
            .done(function(markup)
            {
                handleDoneAvailableFacetsAltered(lastFilterUsed, markup, $checked, markupFrame);
            })
            .done(updateResetElements)
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    function limitNumberOfFilters()
    {
        $('.filter', $form).each(function()
        {
            var $filter = $(this);

            if ('none' === $filter.css('display'))
            {
                $filter.remove();
            }
        });
    }

    function getFilterStringRange()
    {
        var $rangeFromValue = $('input[name=endPrice_start]'),
            rangeFromValue = $rangeFromValue.length === 1
                ? parseFloat($rangeFromValue.val().replace(',', '.'), 10)
                : 0,
            $rangeEndValue = $('input[name=endPrice_end]'),
            rangeEndValue = $rangeEndValue.length === 1
                ? parseFloat($rangeEndValue.val().replace(',', '.'), 10)
                : 999999;

        if (typeof rangeFromValue !== 'number' || isNaN(rangeFromValue))
        {
            rangeFromValue = 0;
        }
        if (typeof rangeEndValue !== 'number' || isNaN(rangeEndValue))
        {
            rangeEndValue = 999999;
        }

        console.log('range values: ' + rangeFromValue + ' - ' + rangeEndValue);

        if (rangeFromValue === 0 && rangeEndValue === 999999)
        {
            return '';
        }

        return 'endPrice%3A%3A1%3A%3A' + (rangeFromValue * 100) + '%3A%3A' + (rangeEndValue * 100) + '%3A%3A0';
    }

    function updateDropdownTrigger()
    {
        var $trigger = $('.filter a.dropdown-trigger');

        $trigger.on('click', function()
        {
            $trigger.removeClass('dropdown-active');

            if ($(this).next('.dropdown')
                .hasClass('hidden'))
            {
                $(this).addClass('dropdown-active');
            }
        });
    }

    function handleEmptyUpcomingFilter($checkedInput, pageCategory)
    {
        if (pageCategory == '00.00.00.00'
            && $checkedInput.length == 1
            && $checkedInput[0].name == 'productFlagsFacet_Upcoming'
            && $('#productFlagsFacet_Upcoming').next().find('.highlight').text() == '(0)')
        {
            $('.not-preorders').addClass('hidden');
            $('.preorders').removeClass('hidden');
        }
        else
        {
            $('.preorders').addClass('hidden');
            $('.not-preorders').removeClass('hidden');
        }
    }

    $form
        .on(orion.constants.EventQChanged, function()
        {
            state = toStateFromQ($('input[name=q]', $form).val());
        })
        .on(['change', orion.constants.EventReset].join(' '), function(e)
        {
            if (
                orion.getShopViewCode() === 'mobile'
                && !document.querySelector('#overlay-more-filter').classList.contains('hidden')
            )
            {
                isMobileFilterOverlay = true;
            }

            console.log('change');

            if ($(e.target).attr('id') === 'sort-selection')
            {
                e.preventDefault();
                console.log('skip form change update');
                return;
            }

            orion.startProcessing('#custom-filter-options, .js-filter-remove-container');

            var
                $checkedInputs = $form.find('.boolean,.size,.color,.multi,.single').find('input:checked'),
                facetGroups = toFacetGroups($checkedInputs),
                rawFilterStringStandard = filterString(facetGroups),

                /*
				 *$checkedRanges = $(".range input:checked", $form),
				 *facetGroupsRange = toFacetGroups($checkedRanges),
				 *rawFilterStringRange = filterStringRange(facetGroupsRange),
				 */
                rawFilterStringRange = getFilterStringRange(),

                lastFilterUsed = (e.type === 'change') ? toNameAndValue(e.target.value)[0] : '',

                rawFilterString = filterEmpty([rawFilterStringStandard, rawFilterStringRange]).join(delimiterFilters),

                q = resetPaginationParameters(state.prefix + rawFilterString),

                pageCategory = orion.toPageCategory(),
                requestAvailableFacets = makeRequestPromiseAvailableFacets(pageCategory, q);

            console.log(rawFilterStringStandard);
            console.log(rawFilterStringRange);

            state = toStateFromQ(updateParameterLastFilterUsed(q, lastFilterUsed));

            function handleDoneAvailableFacets(availableFacetsMarkup)
            {
                if (idLastRequestAvailableFacets !== requestAvailableFacets.requestId)
                {
                    // stale request => discard
                    return;
                }

                handleLastFilterUsed(lastFilterUsed,
                    $.extend({}, facetGroups), pageCategory, $checkedInputs, availableFacetsMarkup);
            }

            updateResetElements();

            if (window.history.replaceState)
            {
                window.history.replaceState({}, '', updateParameterLastFilterUsed('?q=' + q, lastFilterUsed));
                orion.handleLoginRedirectParameter();
            }

            requestAvailableFacets
                .done(handleDoneAvailableFacets)
                .done(updateResetElements)
                .fail(function()
                {
                    // console.log("…available facets request failed");
                })
                .always(function()
                {
                    if (idLastRequestAvailableFacets === requestAvailableFacets.requestId)
                    {
                        if (orion.getShopViewCode() === 'mobile')
                        {
                            document.querySelector('.js-filter__result-count').textContent =
                                document.querySelector('.js-category__result-counter').textContent;
                        }

                        if (isMobileFilterOverlay)
                        {
                            document.querySelector('body').classList.add('no-scroll', 'focus-active');
                            document.querySelector('#overlay-more-filter').classList.remove('hidden');

                            isMobileFilterOverlay = false;
                        }
                    }

                    orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
                });

            $body.trigger(orion.constants.EventFiltersChanged);
        })
        .on('click', '.reset:not(.js-filter-overlay__reset-button)', function(e)
        {
            console.log('click');
            var
                q = $q.val(),
                $filter = $(this).closest('.filter');

            e.preventDefault();

            $q.val(resetPaginationParameters(q));
            $form.trigger(orion.constants.EventQChanged);

            $('input:checked', $filter).prop('checked', false);
            $form.trigger(orion.constants.EventReset);

            handleEmptyUpcomingFilter($('input:checked', $form), orion.toPageCategory());
        })
        .on('touchstart', '.custom-boxes label', function()
        {
            // No-op workaround to make color filter work on first touch on touch devices
            (function()
            {
                return true;
            })();
        })
        .on('submit', function(e)
        {
            console.log('submit');
            e.preventDefault();
        });

    $body
        .on(orion.constants.EventSortCriteriumChanged, updateQFromPageUri)
        .on(orion.constants.EventFiltersMarkupReplaced, limitNumberOfFilters)
        .on(orion.constants.EventFiltersMarkupReplaced, updateDropdownTrigger);

    state = toStateFromQ($q.val());
    restoreFormFromState(state.filters);

    (function()
    {
        var
            lastFilterUsed = new URI(document.location.href).query(true).last,
            $checkedInputs = $form.find('.boolean,.size,.color,.multi,.single').find('input:checked'),
            facetGroups = toFacetGroups($checkedInputs),
            $checkedRanges = $('.range input:checked', $form),
            facetGroupsRange = toFacetGroups($checkedRanges),
            facetGroupsAll = $.extend({}, facetGroups, facetGroupsRange),
            $checked = $checkedInputs.add($checkedRanges),
            pageCategory = orion.toPageCategory(),
            markupFrame = $container;

        handleLastFilterUsed(lastFilterUsed, facetGroupsAll, pageCategory, $checked, markupFrame);
        handleEmptyUpcomingFilter($('input:checked', $form), pageCategory);
    })();

    restoreFormState($('input:checked', $form));
    updateResetElements();
    limitNumberOfFilters();
});
